module.exports = __webpack_public_path__ + "static/media/microsoftEdgeIcon.607858f4.png";